import "../Styles/index.scss";

import "reflect-metadata";
import { defineCustomElement as defineCustomElementCore, type App } from "vue";
import { initializeMaps } from "@wagich/bluc-map";
import { ConfigProgrammatic } from "buefy";

import Flickity from "flickity";
import "flickity-fade";
import imagesLoaded from "imagesloaded";
import { Fancybox } from "@fancyapps/ui";
import Packery from "packery";

import "./plyr";
import { configureApp } from "~/vue/utils";
import { EventOverview } from "./vue/event-overview";
import { EventTimeline } from "./vue/event-timeline";
import { SvgIcon } from "~/common/svg-icon";
import { SiteSearch } from "~/vue/site-search";
import { PersonDetail } from "~/vue/person-detail";
import { TeamFilter } from "~/vue/team-filter";
import { MainNavigation } from "~/navigation/main-navigation";
import { CollapsibleCard } from "~/common/collapsible-card";
import { PopoverCard } from "~/common/popover-card";
import { Cover } from "./cover";
import { NewsInfoscreen } from "./news-infoscreen";

ConfigProgrammatic.setOptions({
	defaultIconComponent: SvgIcon as any,
	defaultIconPack: "icon",
});

function defineAndConfigureCustomElement(component: any) {
	return defineCustomElementCore(component.__vccOpts, {
		shadowRoot: false,
		configureApp,
	});
}
customElements.define("event-timeline", defineAndConfigureCustomElement(EventTimeline));
customElements.define("event-overview", defineAndConfigureCustomElement(EventOverview));
customElements.define("site-search", defineAndConfigureCustomElement(SiteSearch));
customElements.define("team-filter", defineAndConfigureCustomElement(TeamFilter));
customElements.define("main-navigation", defineAndConfigureCustomElement(MainNavigation));
customElements.define("collapsible-card", defineAndConfigureCustomElement(CollapsibleCard));
customElements.define("popover-card", defineAndConfigureCustomElement(PopoverCard));

if (document.querySelector("kb-category") != null) {
	import("./vue/kb-category").then(m => {
		customElements.define("kb-category", defineAndConfigureCustomElement(m.KbCategory));
	});
}
if (document.querySelector("form-trigger") != null) {
	import("./vue/form-trigger").then(m => {
		customElements.define("form-trigger", defineAndConfigureCustomElement(m.FormTrigger));
	});
}

// fancybox image zoom
Fancybox.bind(".asset.is-zoomable", {
	groupAttr: "data-gallery",
	on: {
		initSlides: (_fancybox, slides) => {
			for (const slide of slides) {
				const zoomSrc = slide.triggerEl?.getAttribute("data-zoom-src");
				if (zoomSrc) {
					slide.src = zoomSrc;
				}
			}
		},
	},
});

// subject gallery
const subjectGalleryContent = document.querySelector<HTMLElement>(".subject-gallery-content");
if (subjectGalleryContent != null) {
	imagesLoaded(subjectGalleryContent, () => {
		const flickity = new Flickity(subjectGalleryContent, {
			autoPlay: true,
			cellAlign: "left",
			contain: true,
			pageDots: false
		});
	});
}

// event gallery
const galleryContent = document.querySelector<HTMLElement>(".event-gallery-content");
if (galleryContent != null) {
	imagesLoaded(galleryContent, function () {
		new Packery(galleryContent, {
			itemSelector: ".event-gallery-item",
			columnWidth: ".grid-sizer"
		});
	});
}

// Attach click event listeners to person links to open the PersonDetail modal
for (const element of document.querySelectorAll<HTMLAnchorElement>("a[href^='/api/persons/']")) {
	element.addEventListener("click", (e) => {
		PersonDetail.openFromUrl(new URL(element.href, window.location.origin));
		e.preventDefault();
	});
}

const navOverlay = document.querySelector<HTMLElement>(".nav-overlay");

for (let element of document.querySelectorAll<HTMLElement>(`[data-action]`)) {
	element.addEventListener("click", () => {
		switch (element.dataset.action) {
			case "navigation/toggle":
				navOverlay?.classList.toggle("is-active");
				break;
			case "navigation/close":
				navOverlay?.classList.remove("is-active");
				break;
			case "navigation/open":
				navOverlay?.classList.add("is-active");
				break;
			case "site-search/open":
				SiteSearch.open();
				break;
		}
	});
}


new Cover();
new NewsInfoscreen();

initializeMaps();
